import { RippleAPI } from "ripple-lib";
import { computeBinaryTransactionHash, decode } from "ripple-binary-codec";

export const DecodeXrpRawTx = (rawTxHex) => {
  try {
    const txData = decode(rawTxHex);
    if (!txData.TransactionType || !txData.Account) {
      throw new Error("Not a valid XRP transaction");
    }
    const txid = computeBinaryTransactionHash(rawTxHex);
    return {
      txid,
      ...txData,
    };
  } catch (err) {
    throw new Error(`Failed to decode XRP transaction: ${err.message}`);
  }
};

/**
 * Broadcast a raw XRP transaction
 */
export const PublishXrpRawTx = async (rawTxHex, chainId = 144) => {
  const isTestnet = chainId === 142;
  const serverUrl = isTestnet
    ? "wss://s.altnet.rippletest.net:51233"
    : "wss://s1.ripple.com";

  const api = new RippleAPI({ server: serverUrl });
  try {
    await api.connect();

    const result = await api.submit(rawTxHex);

    if (result.resultCode !== "tesSUCCESS") {
      throw new Error(result.resultMessage || "Broadcast failed");
    }

    return result.tx_json.hash;
  } catch (e) {
    throw new Error(`Failed to publish XRP transaction: ${e.message}`);
  } finally {
    await api.disconnect();
  }
};

export const GetXrpBalance = async (address, chainId = 144) => {
  const isTestnet = chainId === 142;
  const serverUrl = isTestnet
    ? "wss://s.altnet.rippletest.net:51233"
    : "wss://s1.ripple.com";

  const api = new RippleAPI({ server: serverUrl });
  try {
    await api.connect();
    const info = await api.getAccountInfo(address);
    return (parseFloat(info.xrpBalance) * 1e6).toString(); // in drops
  } catch (err) {
    throw new Error(`Failed to get XRP balance: ${err.message}`);
  } finally {
    await api.disconnect();
  }
};

/**
 * Convert drops to XRP
 */
export const FromDrops = (drops) => {
  return (parseInt(drops) / 1e6).toFixed(6);
};
